import { Box, Divider, Drawer, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ThemeMode } from 'config';
import useConfig from 'hooks/useConfig';
import React from 'react';
import { useSelector } from 'store';
import { gridSpacing } from 'store/constant';
import { closeLeftSidebar } from 'store/slices/dual-sidebar';
import MainCard from 'ui-component/cards/MainCard';
import CloseIcon from '@mui/icons-material/Close';
import { ellipsisTextOverflowStyles } from 'themes/common/typography';

interface LeftAppSidebarProps {}

const LeftAppSidebar: React.FC<LeftAppSidebarProps> = () => {
  const { borderRadius } = useConfig();
  const theme = useTheme();
  const downMidXl = useMediaQuery((theme) => theme.breakpoints.down('midxl'));
  const { open, width, title, hideHeader, onClose } = useSelector(
    (state) => state.dualSidebar.left,
  );

  const drawerBG = theme.palette.background.paper;

  return (
    <Drawer
      sx={{
        width: open ? width : 0,
        flexShrink: 0,
        zIndex: { xs: 1100, midxl: 0 },
        height: '100%',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.shorter,
        }),
        mr: 0, // מרווח קבוע מעל md
        ml:{xs: open ? gridSpacing : 0},
        '& .MuiDrawer-paper': {
          height: '100%',
          width: width,
          transition: open
            ? `transform 400ms cubic-bezier(0, 0, 0.2, 1) 0s, width ${theme.transitions.duration.shorter}ms ${theme.transitions.easing.sharp} 0s !important`
            : undefined,
          boxSizing: 'border-box',
          position: 'relative',
          border: 'none',
          borderRadius: { sx: 0, midxl: `${borderRadius}px` },
          overflow: 'hidden',
        },
      }}
      variant={downMidXl ? 'temporary' : 'persistent'}
      anchor="left"
      open={open}
      ModalProps={{ keepMounted: true }}
      onClose={() => (onClose ? onClose() : closeLeftSidebar())}
      transitionDuration={theme.transitions.duration.shorter + 200}
    >
      <MainCard
        sx={{
          bgcolor: { xs: 'transparent', [theme.breakpoints.down('midxl')]: drawerBG },
          height: '100%',
          py: 1.25,
          border: 'none',
        }}
        border={theme.palette.mode !== ThemeMode.DARK}
        content={false}
      >
        <Stack direction="column" height="100%">
          {/* Default header */}
          {!hideHeader && (
            <Box
              sx={{
                px: 2.5,
              }}
            >
              <Box
                sx={{
                  pb: 1.25,
                }}
              >
                <Grid container spacing={1.5} alignItems="center" width="100%">
                  <Grid size="grow" overflow="hidden">
                    <Typography
                      variant="h4"
                      color="text.primary"
                      fontWeight={500}
                      sx={{ ...ellipsisTextOverflowStyles }}
                    >
                      {title}
                    </Typography>
                  </Grid>
                  <Grid size="auto">
                    <IconButton onClick={() => (onClose ? onClose() : closeLeftSidebar())}>
                      <CloseIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Box>
              <Divider />
            </Box>
          )}
          {/* Sidebar body */}
          <Box
            sx={{
              flexGrow: 1,
              overflow: 'hidden',
            }}
          >
            <Box
              id={'left-sidebar-content-wrapper'}
              sx={{
                height: '100%',
                overflow: 'auto',
                pt: 2.5,
                px: 2.5,
                pb: 0.5,
              }}
            ></Box>
          </Box>
        </Stack>
      </MainCard>
    </Drawer>
  );
};

export default LeftAppSidebar; 